import { getEnv } from 'config/env';
import { Env } from 'types';

const urlMap: Record<string, string> = {
  [Env.DEV]: 'http://localhost:4566/image.tonsbergseilforening/',
  [Env.PROD]: 'https://image.tonsbergseilforening.no/',
  [Env.TEST]: '🤷‍♂️',
};

export const imageUrl = () => urlMap[getEnv()];
